// Phone codes come from Twilio Verify, whose "Crewmates" service issues six digits.
// Email codes come from the backend's getOtp() helper, which returns 1000-9999.
// Keep in step with mainapp-twinkle/src/_helper/otp.js (OTP_LENGTH).
export const OTP_LENGTH = { phone: 6, email: 4 };
